


































































































import { Vue, Component } from 'vue-property-decorator';
import XGplayer from '@/components/XGplayer.vue';
import { Swipe, SwipeItem, Lazyload, ImagePreview } from 'vant';
import { getDetail } from '../api';
Vue.use(Swipe).use(SwipeItem).use(Lazyload);
@Component({
  components: {
    XGplayer,
  },
})
export default class Detail extends Vue {
  object: any = {};
  workType: any = '';
  show1: boolean = false;
  show2: boolean = false;
  show3: boolean = false;
  show4: boolean = false;
  show5: boolean = false;
  img: string = '';
  async created() {
    this.$route.query.workType === '乡村学校少年宫劳动教育优秀案例'
      ? (this.show3 = true)
      : this.$route.query.workType === '最受欢迎校外劳动教育实践场所'
      ? (this.show2 = true)
      : this.$route.query.workType === '劳动教育优秀校长'
      ? (this.show5 = true)
      : this.$route.query.workType === '快乐劳动小能手'
      ? (this.show4 = true)
      : (this.show1 = true);
    const res = await getDetail(this.$route.query.id);
    this.object = res.data;
    this.img = res.data.cover[0];
  }
  getImg(imageList: any, index: number) {
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: imageList, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }
  goBack() {
    this.$router.go(-1);
  }
}
